import axios from '../axios';
// 系统字典表查询
export const selectByAnyDictList = data => {
  return axios({
    url: '/api/sys/dict/getDictPage',
    method: 'post',
    data
  })
}

// 系统字典表添加
export const listAdd = data => {
    return axios({
      url: '/api/sys/dict/saveDict',
      method: 'post',
      data
    })
  }

  // 系统字典表修改
export const listUpdate = data => {
    return axios({
      url: '/api/sys/dict/updateDict',
      method: 'post',
      data
    })
  }

    // 系统字典表删除
export const listDel = data => {
    return axios({
      url: '/api/sys/dict/deleteDicts',
      method: 'post',
      data
    })
  }

    // 查询单条
export const getDict = data => {
    return axios({
        url: '/api/sys/dict/getDict',
        method: 'post',
        data
    })
}
// 根据字典类型获取字典值
export const getDictValue = data => {
  return axios({
    url: '/api/sys/dict/getDictValue',
    method: 'post',
    data
  })
}


// 枚举类型维护列表
export const getSysEnumCategoryPage = data => {
  return axios({
    url: '/api/sys/enum/category/getSysEnumCategoryPage',
    method: 'post',
    data
  })
}
export const saveSysEnumCategory = (data) => {
  // 枚举类型维护列表增
  if (!data.categoryId) {
    return axios({
      url: '/api/sys/enum/category/saveSysEnumCategory',
      method: 'post',
      data
    })
  } else { // 枚举类型维护列表改
    return axios({
      url: '/api/sys/enum/category/updateSysEnumCategory',
      method: 'post',
      data
    })
  }
}
// 枚举维护表列表
export const getSysEnumPage = data => {
  return axios({
    url: '/api/sys/enum/getSysEnumPage',
    method: 'post',
    data
  })
}
// 枚举维护表列表保存
export const saveSysEnum = data => {
  return axios({
    url: '/api/sys/enum/saveSysEnum',
    method: 'post',
    data
  })
}
// 枚举维护表列表修改
export const updateSysEnum = data => {
  return axios({
    url: '/api/sys/enum/updateSysEnum',
    method: 'post',
    data
  })
}
// 枚举维护表列表删除
export const deleteSysEnums = data => {
  return axios({
    url: '/api/sys/enum/deleteSysEnums',
    method: 'post',
    data
  })
}


// 仓库分组维护列表
export const getBaseStockGroupPage = data => {
  return axios({
    url: '/api/sys/getBaseStockGroupPage',
    method: 'post',
    data
  })
}
export const saveBaseStockGroup = (data) => {
  // 仓库分组维护列表保存
  if (!data.groupId) {
    return axios({
      url: '/api/sys/saveBaseStockGroup',
      method: 'post',
      data
    })
  } else { // 仓库分组维护列表修改
    return axios({
      url: '/api/sys/updateBaseStockGroup',
      method: 'post',
      data
    })
  }
}
// 仓库分组维护列表删除
export const deleteBaseStockGroups = data => {
  return axios({
    url: '/api/sys/deleteBaseStockGroups',
    method: 'post',
    data
  })
}
// 仓库列表
export const getBaseStockPage = data => {
  return axios({
    url: '/api/sys/getBaseStockPage',
    method: 'post',
    data
  })
}
// 仓库列表保存
export const saveBaseStock = data => {
  return axios({
    url: '/api/sys/saveBaseStock',
    method: 'post',
    data
  })
}
// 仓库列表修改
export const updateBaseStock = data => {
  return axios({
    url: '/api/sys/updateBaseStock',
    method: 'post',
    data
  })
}
// 仓库列表删除
export const deleteBaseStocks = data => {
  return axios({
    url: '/api/sys/deleteBaseStocks',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/dictionary.js